"use client";

import { useState } from "react";
import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import BookUpload from "./BookUpload";

// "Add Book" button → modal, matching the original FileUpload UX (a button that
// opens a dialog) rather than an always-visible inline form.
export default function AddBookDialog() {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-app-accent font-bold text-app-on-accent transition-opacity duration-300 hover:opacity-90">
          <Plus className="mr-2 h-4 w-4" /> Add Book
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>Add a book</DialogTitle>
        </DialogHeader>
        <BookUpload embedded onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
